import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyNewPage from "@/pages/admin/surveys/new";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <AdminSurveyNewPage
      userCanEditAllSurveys={userCanEditAllSurveys}
      userCanViewAllSurveys={userCanViewAllSurveys}
    />
  );
}
